const React = require('react');
const ReactIntl = require('react-intl');
const injectIntl = ReactIntl.injectIntl;
const IntlProvider = ReactIntl.IntlProvider;
const defaultMessages = require('../../i18n/messages/default');
const TOTPWidget = require('../../components/TOTPWidget/TOTPWidget');
const Header = require('../Header/Header');
const PageCase = require('../PageCase/PageCase.js');
const LoginStore = require('../../stores/LoginStore');
const AppConstants = require('../../constants/AppConstants');
const UrlUtils = require('../../utils/urlUtils');
const FooterMinimal = require('../Footer/FooterMinimal');
require("../../components/TOTPWidget/widget.less");
require("./validate-otp.less");

class ValidateOtp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            emailId: '',
            mobileNumber: '',
            notificationChannel: "email",
            showTOTPControl: AppConstants.TWO_FA_OTP,
            isPhoneNumber: false,
            caretPosition: null,
            localeId: this.props.localeId,
            mailToken: '',
            backToLoginUrl:'',
        };
        this.getBackToLoginUrl = this.getBackToLoginUrl.bind(this);
    }

    componentDidMount() {
        this.getBackToLoginUrl();
    }

    onLocalChange(localeId) {
        this.setState({ localeId: localeId });
    }

    getBackToLoginUrl(backLink){
        UrlUtils.delete_cookie(AppConstants.cookie.METRO_IDENTITY);
        this.setState({ backToLoginUrl: backLink });
    }

    renderTOTPForm() {
        let props = this.props;
        let headerMessage = this.props.intl.formatMessage(defaultMessages['validateOtpHeaderMsg']);
        const imgSrc =  "assets/images/Icon_medium_arrow-left.svg";
        return (
            <div className="portraitCenteredEmployee otp-mobile-container">
                <div className="employeeBoxContainer container">
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                    <div className="col-md-6 col-sm-8 col-xs-12 larger-device-width">
                    <div className="row whiteContainer larger-device-width smaller-device otp-large otp-middle-view">
                        <div className="col-xs-12 smaller-device-inside-wrap">
                        <div className="row">
                            <div className="form-group headerOTP">
                                <a href="javascript:void(0)" onClick={
                                    ()=> {
                                        window.location = this.state.backToLoginUrl}
                                    } className="otp-backlink-header">
                                    <img className="otp-backlink-img" id='otp-back-link'  alt='otp-backlink' src={imgSrc}/>      
                                </a>
                                <h1>{headerMessage}</h1>
                            </div>
                        </div>
                        <TOTPWidget
                            {... this.props}
                            phone={this.EmailId}
                            login={this.EmailId}
                            backArrowLink={this.getBackToLoginUrl}
                            idToken={this.state.mailToken}
                            isForgotPasswordFlow={this.state.isPhoneNumber}
                            twoFaAuthMethod= {this.state.showTOTPControl}
                        />
                        </div>
                    </div>
                    </div>
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                </div>
            </div>
        );
    }

    renderFooter() {
        return (
            <IntlProvider locale={this.state.localeId} messages={this.props.translations}>
                <FooterMinimal {...this.props} locale={this.state.localeId} onLocalChange={this.onLocalChange} />
            </IntlProvider>
        )
    }
    
    render () {
        return (
            <PageCase
                header={<Header />}
                content={this.renderTOTPForm()}
                footer={this.renderFooter()}>
            </PageCase>
        );
    }
}

module.exports = injectIntl(ValidateOtp);